const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Shares Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('CustomCopy', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
    return $resource(appConfiguration.apiUrl + '/learn/v3/companies/:subresource/:action', null, {
      edit: {params: {subresource: '', action: 'edit-copy'}, method: 'POST', isArray: false},
      remove: {params: {subresources: '', action: 'remove-copy'}, method: 'POST', isArray: false}
    });
}])